import axios from 'axios';
import { LegalEntityModel, PersonModel } from 'app/shared/oib/oib.model';
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';
import error = toast.error;
import { messages } from 'app/config/constants';
import success = toast.success;

export const fetchPersonEntity = async (oib: string): Promise<PersonModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get<PersonModel>(`api/oib/person/${oib}`)
      .then(result => {
        showToast(success, messages.OIB_FETCHED);
        resolve(result.data);
      })
      .catch(err => {
        showToast(error, err.response.data.detail);
      });
  });
};

export const fetchLegalEntity = async (oib: string): Promise<LegalEntityModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get<LegalEntityModel>(`api/oib/legal-entity/${oib}`)
      .then(result => {
        showToast(success, messages.OIB_FETCHED);
        resolve(result.data);
      })
      .catch(err => {
        showToast(error, err.response.data.detail);
      });
  });
};
